import type { SeatMapLocalityDto } from '@/lib/api/taquilla';

/**
 * Color por localidad del mapa de asientos (F5, tienda Mi Boleta).
 *
 * Extraído de `SeatMapCanvas.tsx`: era un `export` no-componente conviviendo
 * con el componente, lo que rompía el Fast Refresh de Vite
 * (`react-refresh/only-export-components`). Vive con su paleta porque la usa,
 * y `SeatMapCanvas` reimporta `LOCALITY_PALETTE` para sus otros usos.
 */

// Paleta estable por índice de localidad (cuando no hay color_hex propio).
export const LOCALITY_PALETTE = [
  '#7c3aed', // violeta
  '#0ea5e9', // celeste
  '#f59e0b', // ámbar
  '#10b981', // esmeralda
  '#ef4444', // rojo
  '#ec4899', // rosa
  '#14b8a6', // teal
  '#8b5cf6', // púrpura
  '#f97316', // naranja
  '#3b82f6', // azul
];

export function localityColor(loc: SeatMapLocalityDto, index: number): string {
  return loc.color_hex || LOCALITY_PALETTE[index % LOCALITY_PALETTE.length];
}
